export default (apiMethods, endpoints) => ({

    getSubscriptions: () => {
        return apiMethods.get(endpoints.GET_SUBSCRIPTIONS_ENDPOINT);
    },

    getSubscriptionsByDomain: (domainId) => {
        return apiMethods.get(endpoints.GET_SUBSCRIPTION_BY_DOMAIN_ENDPOINT + '/' + domainId);
    },

    addSubscriptions: (subscriptions) => {
        return apiMethods.post(endpoints.ADD_SUBSCRIPTIONS_ENDPOINT, subscriptions);
    },

    updateSubscriptionPayment: (merchantId, subscriptionId, isPayed) => {
        return apiMethods.put(endpoints.UPDATE_SUBSCRIPTION_PAYMENT_BY_MERCHANT_ENDPOINT + '/' + merchantId + '/' + subscriptionId, { isPayed });
    },

    upgradeSubscription: (currentSubscriptionId, toUpgradeSubscriptionId) => {
        return apiMethods.post(endpoints.UPGRADE_SUBSCRIPTION_ENDPOINT, {
            oldSubscription: currentSubscriptionId,
            newSubscription: toUpgradeSubscriptionId
        })
    },

    addSubscription: (subscriptionId) => {
        return apiMethods.post(endpoints.ADD_SUBSCRIPTION_ENDPOINT, {
            subscriptionId
        })
    },
     
    getMyAccountSubscriptions: () => {
        return apiMethods.get(endpoints.GET_MY_ACCOUNT_SUBSCRIPTIONS_ENDPOINT);
    }

})



// WEBPACK FOOTER //
// ./src/lib/api-subscription.js